// extracted by mini-css-extract-plugin
export var container = "WasteReportContent-module--container---28Sr";
export var content = "WasteReportContent-module--content--0Ns16";
export var noProducts = "WasteReportContent-module--noProducts--qKNpo";
export var subHeader = "WasteReportContent-module--subHeader--z8GrO";